import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { motion } from "framer-motion";

import BancoIcon from "../../static/media/home/Banco.webp";
import EnvioIcon from "../../static/media/home/Envio.webp";

const C = {
  dark: "#0C1F2F",
  navy: "#0057A8",
  navyDark: "#003D73",
  gold: "#FFCD00",
  goldDark: "#E6B800",
  teal: "#5BC8AF",
  gray: "#F5F7FA",
  white: "#ffffff",
};

const WHATSAPP_URL =
  "https://api.whatsapp.com/send/?phone=593987724998&text=Hola+quiero+m%C3%A1s+informaci%C3%B3n&type=phone_number&app_absent=0";

const BankIcon = () => (
  <Box
    component="img"
    src={BancoIcon}
    alt="Banco"
    sx={{ width: 64, height: 46, objectFit: "contain" }}
  />
);
const TruckIcon = () => (
  <Box
    component="img"
    src={EnvioIcon}
    alt="Envío"
    sx={{ width: 64, height: 46, objectFit: "contain" }}
  />
);
const WhatsAppSVG = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.87.5 3.62 1.43 5.13L2 22l5.13-1.5a9.86 9.86 0 0 0 4.91 1.31c5.46 0 9.91-4.45 9.91-9.9C21.95 6.45 17.5 2 12.04 2zm0 17.9c-1.62 0-3.13-.45-4.42-1.24l-.32-.19-3.04.89.9-2.96-.21-.32a8.06 8.06 0 0 1-1.27-4.17c0-4.46 3.63-8.09 8.36-8.09 4.46 0 8.09 3.63 8.09 8.09 0 4.46-3.63 8-8.09 8zm4.46-6.05c-.24-.12-1.43-.71-1.65-.79-.22-.08-.38-.12-.55.12-.16.24-.62.79-.76.95-.14.16-.28.18-.52.06-.24-.12-1.01-.37-1.92-1.19-.71-.63-1.19-1.41-1.33-1.65-.14-.24-.01-.37.11-.49.12-.12.27-.31.4-.47.13-.16.18-.27.27-.45.09-.18.04-.33-.04-.45-.08-.12-.5-1.21-.69-1.65-.18-.43-.37-.37-.51-.38-.13-.01-.28-.01-.43-.01-.15 0-.39.06-.6.3-.21.24-.8.78-.8 1.9s.82 2.21.93 2.36c.11.15 1.58 2.41 3.83 3.29 2.25.88 2.25.59 2.66.55.41-.04 1.32-.54 1.5-1.06.18-.52.18-.97.13-1.06-.05-.09-.18-.15-.42-.27z" />
  </svg>
);

function InfoCard({ icon, title, children, delay = 0 }) {
  return (
    <Box
      component={motion.div}
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.55, ease: "easeOut", delay }}
      sx={{
        background: C.white,
        borderRadius: "20px",
        p: { xs: "24px 20px", md: "32px 28px" },
        flex: 1,
        minWidth: 0,
        boxShadow: "0 8px 32px rgba(0,0,0,.14)",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          width: 64,
          height: 64,
          borderRadius: "14px",
          background: `${C.gold}22`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mb: 2.5,
          flexShrink: 0,
        }}
      >
        {icon}
      </Box>
      <Typography
        sx={{
          color: C.dark,
          fontWeight: 800,
          fontSize: { xs: 17, md: 19 },
          mb: 1.2,
          letterSpacing: "-.01em",
        }}
      >
        {title}
      </Typography>
      {children}
    </Box>
  );
}

export default function PagoEnvios() {
  return (
    <Box
      id="pago-envios"
      sx={{
        background: `linear-gradient(180deg, ${C.navy} 0%, ${C.navyDark} 100%)`,
        pt: { xs: "64px", md: "88px" },
        pb: 0,
        overflow: "hidden",
        boxSizing: "border-box",
      }}
    >
      <Box
        sx={{
          maxWidth: "1100px",
          mx: "auto",
          width: "100%",
          px: { xs: "20px", sm: "32px", md: "40px" },
          boxSizing: "border-box",
        }}
      >
        <Box
          component={motion.div}
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          sx={{ textAlign: "center", mb: { xs: 5, md: 7 } }}
        >
          <Typography
            variant="h2"
            sx={{
              color: C.white,
              fontWeight: 900,
              fontSize: { xs: 24, sm: 30, md: 38 },
              letterSpacing: "-.02em",
              lineHeight: 1.15,
            }}
          >
            Pago Fácil, Envíos Seguros
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: { xs: "20px", md: "28px" },
            alignItems: "stretch",
          }}
        >
          <InfoCard
            icon={<BankIcon />}
            title="Transferencia Bancaria"
            delay={0}
          >
            <Typography
              sx={{
                color: "#5c6c7a",
                fontSize: { xs: 13.5, md: 14.5 },
                lineHeight: 1.65,
                mb: 2.5,
              }}
            >
              ¡Aceptamos transferencia bancaria como pago! Un medio rápido y
              seguro para confirmar tu pedido sin complicaciones.
            </Typography>
            <Box
              sx={{
                mt: "auto",
                borderTop: "1px solid rgba(12,31,47,0.08)",
                pt: 2.5,
              }}
            >
              <Typography
                sx={{ color: C.dark, fontWeight: 700, fontSize: 13.5, mb: 1 }}
              >
                ¿Tienes alguna pregunta?
              </Typography>
              <Box
                component={motion.a}
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.03 }}
                whileTap={{ scale: 0.97 }}
                sx={{
                  position: "relative",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "10px",
                  textDecoration: "none",
                  background: C.navy,
                  color: C.white,
                  fontWeight: 800,
                  fontSize: 13.5,
                  px: "22px",
                  py: "11px",
                  borderRadius: "999px",
                  boxShadow: "0 8px 20px rgba(0,87,168,0.40)",
                  transition: "background .2s",
                  "&:hover": { background: C.navyDark },
                }}
              >
                <Box
                  aria-hidden="true"
                  sx={{
                    position: "absolute",
                    inset: 0,
                    borderRadius: "999px",
                    border: `2px solid ${C.navy}`,
                    animation: "wa-pulse 2.2s ease-out infinite",
                    "@keyframes wa-pulse": {
                      "0%": { transform: "scale(1)", opacity: 0.6 },
                      "100%": { transform: "scale(1.35)", opacity: 0 },
                    },
                  }}
                />
                <WhatsAppSVG />
                ¡Contáctanos!
              </Box>
            </Box>
          </InfoCard>

          <InfoCard icon={<TruckIcon />} title="Medios de Envío" delay={0.12}>
            <Typography
              sx={{
                color: "#5c6c7a",
                fontSize: { xs: 13.5, md: 14.5 },
                lineHeight: 1.65,
              }}
            >
              ¡Envíos a nivel nacional y entregas en Quito! Recibe tu pedido
              estés donde estés, con la misma atención de siempre.
            </Typography>
            <Box
              sx={{
                mt: 3,
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "12px",
              }}
            >
              {[
                { num: "24h", label: "Despacho Quito" },
                { num: "48h", label: "Resto del país" },
              ].map((stat) => (
                <Box
                  key={stat.label}
                  sx={{
                    background: C.gray,
                    borderRadius: "12px",
                    p: "12px 14px",
                    textAlign: "center",
                  }}
                >
                  <Typography
                    sx={{
                      color: C.navy,
                      fontWeight: 900,
                      fontSize: { xs: 22, md: 26 },
                      lineHeight: 1,
                      mb: 0.4,
                    }}
                  >
                    {stat.num}
                  </Typography>
                  <Typography
                    sx={{ color: "#5c6c7a", fontSize: 11, fontWeight: 600 }}
                  >
                    {stat.label}
                  </Typography>
                </Box>
              ))}
            </Box>
          </InfoCard>
        </Box>
      </Box>

      {/* Transición extendida hacia oscuro para el footer */}
      <Box
        sx={{
          height: { xs: "120px", md: "180px" },
          background: `linear-gradient(180deg, ${C.navyDark} 0%, ${C.dark} 100%)`,
          mt: { xs: 6, md: 8 },
        }}
      />
    </Box>
  );
}
